import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer } from '@material-ui/core';
import { ActionButton } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import LanguageButton from 'components/organisms/Language/LanguageButton';

import { SidebarNav } from './components';

// const loginUrl = process.env.REACT_APP_LOGIN_URL;
const loginUrl = 'https://fvv-al.ning.com/main/authorization/signIn?target=https%3A%2F%2Ffvv-al.ning.com%2F';
const lbmsUrl = 'https://smbv.fvv.al';
const searchUrl = './search?q=';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: '100%',
    maxWidth: 325,
    backgroundColor: '#ededed',
  },
  root: {
    height: '100%',
    padding: theme.spacing(1),
  },
  nav: {
    marginBottom: theme.spacing(1),
  },
  loginButton: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 15,
    marginLeft: 30,
    marginRight: 30,
    marginBottom: theme.spacing(4),
    color: 'white',
    backgroundColor: '#981B49',
    border: '2px solid #981B49',
    '&:hover': {
      color: '#981B49',
      backgroundColor: 'transparent',
    },
  },
  languageButtonContainer: {
    marginRight: 30,
    marginLeft: 30,
    marginBottom: theme.spacing(4),
  },
  lbmsButton: {
    fontSize: 14,
    paddingLeft: 2,
    paddingRight: 2,
    backgroundColor: '#0049a8',
    border: '2px solid #0049a8',
    '&:hover': {
      color: '#0049a8',
      backgroundColor: 'transparent',
    },
  },
}));

const Sidebar = props => {
  const { pages, open, variant, onClose, className, ...rest } = props;
  const { t } = useTranslation();

  const classes = useStyles();

  return (
    <Drawer
      anchor="left"
      className={classes.root}
      classes={{ paper: classes.drawer }}
      onClose={() => onClose()}
      open={open}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <SidebarNav className={classes.nav} pages={pages} onClose={onClose} />
      </div>

      <div className={classes.languageButtonContainer}>
        <LanguageButton />
      </div>
      <ActionButton
        variant="contained"
        size="small"
        className={clsx(classes.loginButton)}
        href={searchUrl}
      >
        {t('HOME_PAGE.SEARCH')}
      </ActionButton>
      <ActionButton
        variant="contained"
        color="primary"
        size="small"
        className={clsx(classes.loginButton)}
        href={loginUrl}
        target="_blank"
      >
        {t('HOME_PAGE.LOG_IN')}
      </ActionButton>
      <ActionButton
          variant="contained"
          color="success"
          size="small"
          className={clsx(classes.loginButton, classes.lbmsButton)}
          href={lbmsUrl}
          target="_blank"
      >
        {t('HOME_PAGE.LBMS')}
      </ActionButton>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
